import { Type } from '@angular/core';
import { Polycom250Component } from '../devices/polycom-devices/polycom-250/polycom-250.component';
import { Polycom350Component } from '../devices/polycom-devices/polycom-350/polycom-350.component';
import { Polycom450Component } from '../devices/polycom-devices/polycom-450/polycom-450.component';

export const POLYCOM_DEVICES_COMPONENTS: Record<string, Type<any>> = {
  VVX250: Polycom250Component,
  VVX350: Polycom350Component,
  VVX450: Polycom450Component,
};
